import create from 'zustand'
import { configurePersist } from 'zustand-persist'

const { persist, purge } = configurePersist({
  storage: localStorage,
})

const useStore = create(
  persist({
    key: 'nav', // required, child key of storage
    allowlist: ['page'], // optional, will save everything if allowlist is undefined
  },
  set => ({

    tableName: 'patients',
    setTableName: (payload) => set({ tableName: payload }),
    tableUpdated: true,
    setTableUpdated: (payload) => set({ tableUpdated: payload }),
    pagePatient: 0,
    setPagePatient: (payload) => set({ pagePatient: payload }),
    pageStaff: 0,
    setPageStaff: (payload) => set({ pageStaff: payload }),
    pagePharmacy: 0,
    setPagePharmacy: (payload) => set({ pagePharmacy: payload }),
  }))
)

export { persist, purge, useStore };

// export default useStore;